import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { SetToken } from '@app/modules/core/actions/auth.actions';
import { LoadSelfSuccess } from '@app/modules/core/actions/user.actions';
import { AuthService } from '@app/services/api/auth.service';
import { UserService } from '@app/services/api/user.service';
import * as fromRoot from '@core/reducers/root.reducer';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { WebsocketService } from '@app/services/websocket.service';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {
  me$ = this.store.pipe(select(fromRoot.getMe));
  me;
  constructor(
    private store: Store<any>,
    private router: Router,
    private auth: AuthService,
    private api: UserService,
    private ws: WebsocketService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
      const cookie = this.auth.getCookie();
    if (cookie) {
      this.store.dispatch(new SetToken(cookie));
      return this.api.getMe().pipe(
        switchMap(me => {
          if (me) {
            this.store.dispatch(new LoadSelfSuccess(me));
            this.ws.connect(cookie);

            return of(true);
          } else {
            return of(false);
          }
        })
      );
    } else {
      const redirectOptions = Object.assign(
        { skipLocationChange: true },
        state ? { queryParams: { returnUrl: state.url } } : {}
      );

      if(environment.ADFS_ONLY){
        this.router.navigate(['adfs'], redirectOptions)
      }else{
        this.router.navigate(['login'], redirectOptions)
      }

      return false;
    }
  }
}
